import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'fl-multi-quantity-control',
  templateUrl: './multi-quantity-control.component.html',
  styleUrls: ['./multi-quantity-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiQuantityControlComponent implements OnInit, OnDestroy {
  @Input()
  public value: string;
  @Input()
  public formArray: FormArray;

  public control: FormControl;

  private _onDestroy$ = new Subject();

  constructor(private _fb: FormBuilder) {}

  public inputValueChanged(event: any) {
    const value = this.toInteger(event.target.value);
    event.target.value = value < 0 ? 0 : value;
  }

  public ngOnInit() {
    this.control = new FormControl(
      this.formArray.controls.filter((c) => c.value === this.value).length,
    );

    this.control.valueChanges
      .pipe(distinctUntilChanged(), takeUntil(this._onDestroy$))
      .subscribe((ctrlValue) => {
        const val = this.toInteger(ctrlValue);
        for (let i = 0; i < this.formArray.length; i++) {
          const ctrl = this.formArray.at(i);
          if (ctrl.value === this.value) {
            this.formArray.removeAt(i);
            i--;
          }
        }
        for (let i = 0; i < val; i++) {
          this.formArray.push(new FormControl(this.value));
        }
      });
  }

  public ngOnDestroy() {
    this._onDestroy$.next();
  }

  public toInteger(value: any) {
    return Math.floor(value);
  }
}
